import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

import { CrmService } from './CrmService';
import { LicenseRebootstrapService } from './LicenseRebootstrapService';

enum Type {
  Crm = 'Crm',
  LicenseRebootstrap = 'LicenseRebootstrap',
  Consent20ProfileConsentMigration = 'Consent20ProfileConsentMigration',
}

@Component({
  selector: 'app-account-unique-identifiers',
  templateUrl: './account-unique-identifiers.component.html',
  styleUrls: ['./account-unique-identifiers.component.scss'],
  providers: [CrmService, LicenseRebootstrapService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountUniqueIdentifiersComponent {
  @Input() set isCrmKeyspaceCreating(isCrmKeyspaceCreating: boolean) {
    this.crmService.crmKeyspaceTimeoutInProgress(isCrmKeyspaceCreating);
  }
  @Input() set isCrmKeyspaceTimeoutFailed(isCrmKeyspaceTimeoutFailed: boolean) {
    this.crmService.crmKeyspaceTimeoutFailed(isCrmKeyspaceTimeoutFailed);
  }
  @Input() set rebootstrapLicensesIsLoading(
    rebootstrapLicensesIsLoading: boolean,
  ) {
    this.licenseRebootstrapService.rebootstrapLicensesInProgress(
      rebootstrapLicensesIsLoading,
    );
  }
  @Input() set rebootstrapLicensesTimeoutFailed(
    rebootstrapLicensesTimeoutFailed: boolean,
  ) {
    this.licenseRebootstrapService.rebootstrapLicensesTimeoutFailed(
      rebootstrapLicensesTimeoutFailed,
    );
  }
  @Input() canCreateCrmKeyspace: boolean;
  @Input() hasWawBackOffice: boolean;
  @Output() addCrm = new EventEmitter<void>();
  @Output() rebootstrapLicenses = new EventEmitter<void>();

  public Type = Type;
  public hasConsent20FullyMigratedAndEnabled = false;
  public formGroup: FormGroup;

  get crmGroup() {
    return this.formGroup.get(Type.Crm);
  }

  get rebootstrapLicensesGroup() {
    return this.formGroup.get(Type.LicenseRebootstrap);
  }

  constructor(
    private readonly fb: FormBuilder,
    private readonly licenseRebootstrapService: LicenseRebootstrapService,
    private readonly crmService: CrmService,
  ) {
    this.licenseRebootstrapService.init(this.rebootstrapLicensesCb.bind(this));
    this.crmService.init(this.addCrmCb.bind(this));

    this.formGroup = this.fb.group({
      [Type.Crm]: this.crmService.group,
      [Type.LicenseRebootstrap]: this.licenseRebootstrapService.group,
    });
  }

  addCrmCb() {
    this.addCrm.emit();
  }

  rebootstrapLicensesCb() {
    this.rebootstrapLicenses.emit();
  }
}
